<template>
  <div
    class="save"
    :class="{ 'save-isDisabled': disabled }"
    :style="{ width }"
    @click.stop="emitEvent($event)"
  >
    {{ text }}
  </div>
</template>
<script>
export default {
  name: "SaveButton",
  props: {
    text: {
      type: String,
      default: "Save"
    },
    width: {
      type: String,
      default: "210px"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitEvent(event) {
      if (this.disabled) {
        return;
      }
      this.$emit("onSave");
    }
  }
};
</script>
<style>
.save {
  align-items: center;
  background: var(--component_modals_common_saveButton_save_background);
  border: var(--component_modals_common_saveButton_save_border);
  border-radius: var(--component_modals_common_saveButton_save_border-radius);
  color: var(--component_modals_common_saveButton_save_color);
  display: flex;
  font-family: var(--component_modals_common_saveButton_save_font-family);
  font-size: var(--component_modals_common_saveButton_save_font-size);
  height: 65px;
  justify-content: center;
  letter-spacing: 1.84px;
  padding: var(--component_modals_common_saveButton_save_padding);
}
.save-isDisabled {
  opacity: 0.4;
}
</style>
